// BACKEND-API-TRIGGER: delete this file when pipelines expose triggerSpec.name `api`.
import i18n from '~/common/helpers/i18n';
import { shouldDisplayTriggerAsApi } from '~/scenes/Build/scenes/Pipelines/components/ConfigureApiModal/configureApiPipelineUtils';
import type { PipelineEntityLike } from '~/scenes/Build/scenes/Pipelines/components/ConfigureApiModal/configureApiPipelineUtils';

export type TriggerTooltipPipelineLike = Pick<
  PipelineEntityLike,
  | 'triggerSpec'
  | 'hasApiTrigger'
  | 'isUsingApiTrigger'
  | 'restApiTriggerRoutes'
  | 'flowSpec'
  | 'apiExposed'
>;

export function resolveTriggerTooltipName(
  input: TriggerTooltipPipelineLike
): string | undefined {
  const spec = input.triggerSpec;
  if (!spec?.name) {
    return undefined;
  }
  if (shouldDisplayTriggerAsApi(input)) {
    return i18n.t('scenes.pipelines.actions.create_api');
  }
  return spec.name;
}
